import { appendQueryString } from "./appendQueryString";
import { toQueryString } from "./toQueryString";

type Params = Record<string, unknown>;

interface Args {
  params?: Params;
}

export const settingsPath = {
  paywallsAdminDashboard: {
    charges: ({ params = {} }: Args = {}) =>
      appendQueryString("/settings/paywall_charges", params),
    subscriptions: ({ params = {} }: Args = {}) =>
      appendQueryString("/settings/paywall_subscriptions", params),
  },
  files: {
    index: ({ params = {} }: Args = {}) =>
      appendQueryString("/settings/files", params),
  },
  postsDashboard: {
    index: ({ params = {} }: Args = {}) =>
      appendQueryString("/settings/posts", params),
  },
  eventsDashboard: {
    index: ({ params = {} }: Args = {}) =>
      appendQueryString("/settings/events", params),
  },
  pagesDashboard: {
    index: ({ params = {} }: Args = {}) =>
      appendQueryString("/settings/pages", params),
  },
  coursesDashboard: {
    index: ({ params = {} }: Args = {}) =>
      appendQueryString("/settings/courses", params),
  },
  moderationDashboard: {
    index: ({ params = {} }: Args = {}) =>
      appendQueryString("/settings/moderation", params),
  },
  topicsDashboard: {
    index: ({ params = {} }: Args = {}) =>
      appendQueryString("/settings/topics", params),
  },
  formsDashboard: {
    index: ({ params = {} }: Args = {}) =>
      appendQueryString("/settings/emails/forms", params),
  },
  spacesDashboard: {
    index: ({ params = {} }: Args = {}) =>
      appendQueryString("/settings/spaces", params),
  },
  activityLogsDashboard: {
    index: ({ params = {} }: Args = {}) =>
      appendQueryString("/settings/members/activity_logs", params),
  },
};
export const communityBillingPath = () => "/settings/billing" as const;
export const communityInvoicesPath = () => "/settings/invoices" as const;
export const communityPaymentDetailsPath = () =>
  "/settings/payment_details" as const;
export const landingPageSettingsPath = () => "/settings/home";
export const attachmentFilesPath = () => "/settings/communities/attached_files";

export const flaggedContent = {
  index: ({ params }: Args = {}) =>
    `/settings/moderation?${toQueryString(params)}`,
};

export const paymentsPath = {
  accountSession: () => "/settings/payments/account_session",
  create: () => "/settings/payments",
  embeddedOnboarding: () => "/settings/payments/onboarding",
  existingAccountOnboarding: () =>
    "/settings/payments/onboarding/existing_account",
  onboarding: () => "/settings/payments/onboarding",
  onboardingFallback: () => "/settings/payments/onboarding/fallback",
  onboardingStepChange: () => "/settings/payments/onboarding_step_change",
  refresh: () => "/settings/payments/refresh",
  refreshStatus: () => "/settings/payments/refresh_status",
  revokeAccountSession: () => "/settings/payments/revoke_account_session",
};
